<template>
	<div
		:id="`borger-dk-${_uid}`"
		:class="[
			'c-block-list-borger-dk-custom',
			'w-5col >=768:w-8col max-w-full mx-auto',
		]"
	>
		<div
			v-if="elements && elements.length"
			class="text-h8 uppercase mb-2xs"
			v-text="'Dette indhold kommer fra borger.dk'"
		></div>

		<AccordionLayout v-bind="{ title, elements, id }">
			<template #title>
				<LongReadTarget
					v-if="title"
					:container-id="`borger-dk-${_uid}`"
					:title="title"
				>
					<BaseH2
						tag="h2"
						class="text-primary-button"
						v-text="title"
					/>
				</LongReadTarget>
			</template>

			<template #header="{ item }">
				<BaseH3 tag="h3" v-text="item.title"></BaseH3>
			</template>

			<template #panel="{ item }">
				<span class="s-rich-text" v-html="item.content"></span>
			</template>
		</AccordionLayout>
	</div>
</template>

<script>
import AccordionLayout from '~/components/shared/AccordionLayout';
import LongReadTarget from '~/citi-baseline/components/LongReadTarget';

export default {
	name: 'BlockListBorgerDkCustom',
	components: { AccordionLayout, LongReadTarget },
	inheritAttrs: false,

	props: {
		title: {
			type: String,
			required: false,
		},

		informationcontainer: {
			type: Object,
			default: () => {},
		},
		id: {
			type: String,
			required: false,
		},
	},

	computed: {
		elements() {
			if (this.informationcontainer?.elements) {
				const { elements: el } = this.informationcontainer;
				const unflattenedResponse = el.map((item) => {
					return item.microArticles || item;
				});

				const response = [];
				unflattenedResponse.forEach((e) => {
					!Array.isArray(e) && response.push(e);
					Array.isArray(e) &&
						e.forEach((item) =>
							response.push({ ...item, key: item.id })
						);
				});

				return response;
			}

			return [];
		},
	},
};
</script>
